import { useEffect } from "react";

import "components/order/style/ShopInfo.css";
const { Kakao } = window;
const KakaoNavi = ({  name ,lng,lat,}) => {
    useEffect(() => {
        Kakao.init("0ff363cf12f3e830214e7305403fcf5f"); // 사용하려는 앱의 JavaScript 키 입력
        let container = document.getElementById("navi");
        container.addEventListener("click", () => {
        Kakao.Navi.start({
            name: name, // 목적지 이름
            x: lng, // 목적지 x 좌표
            y: lat, // 목적지 y 좌표
            coordType: "wgs84", // 좌표계 타입
          })
        });
    });
    return (
        <div id="navi" className="" style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>          
                <img src="https://developers.kakao.com/assets/img/about/buttons/navi/kakaonavi_btn_medium.png"
                alt="길 안내하기 버튼" />         
        </div>
      );
}
export default KakaoNavi;
